import { bannerShow } from 'shared/actions/globals';
import GoogletagUnmount from './GoogletagUnmount';

import { targetingCheck, time, defineOutOfPageSlot, scrollFun } from './TargetingCheck';

export default ({ slots = [], componentWillUnmount, googletagRefresh }) => {
  const googletagCmdInistaillArr = [];
  const googletagCmdRefreshArr = [];

  if (!(typeof window === 'object' && window.googletag && window.googletag.defineSlot)) {
    return null;
  }

  if (!window.AbStor.SlotStart) {
    window.AbStor.DefineSlot = {};
    window.AbStor.KeyIdDefineSlot = {};
    window.AbStor.SetTimeoutrefresh = null;
    window.AbStor.adUnitNameId = {};
    window.AbStor.keyTarget = {};
    window.AbStor.SlotStart = false;
    window.AbStor.blockAbInstall = false;
    window.AbStor.blockAbInstallNext = false;
    window.onscroll = scrollFun;
    window.addEventListener('orientationchange', scrollFun, false);
    window.onresize = scrollFun;
  }
  if (componentWillUnmount) {
    return GoogletagUnmount({ googletag: window.googletag, componentWillUnmount });
  }
  if (googletagRefresh) {
    time(0);

    return '';
  }

  const googletagCmdInistaill = data => {
    /*  window.googletag.cmd.push(() => { */
    let bul;
    data.map(
      ({ dfpNetworkId = '', adUnit = '', sizes = [], slotId = '', targetingArguments }, b) => {
        const Target = targetingCheck(targetingArguments);
        const TargetingArgumentsString = `${Object.values(Target).join()}___${(window.location &&
          window.location.href) ||
          ''}`;
        if (
          !window.AbStor.DefineSlot[adUnit] &&
          !window.AbStor.KeyIdDefineSlot[slotId] &&
          Target &&
          dfpNetworkId &&
          adUnit &&
          sizes &&
          slotId
        ) {
          window.AbStor.KeyIdDefineSlot[slotId] = true;
          let defineSlot;
          if (defineOutOfPageSlot[adUnit]) {
            defineSlot = window.googletag.defineOutOfPageSlot(`/${dfpNetworkId}/${adUnit}`, slotId);
          } else {
            defineSlot = window.googletag.defineSlot(`/${dfpNetworkId}/${adUnit}`, sizes, slotId);
          }
          if (!defineSlot) {
            return console.error(`/${dfpNetworkId}/${adUnit}`, sizes, slotId);
          }
          if (__DEVBANNER__) {
            console.info(Target, 'googletagCmdInistaill-------------', b);
          }

          bul = true;

          window.AbStor.DefineSlot[adUnit] = defineSlot.addService(window.googletag.pubads());

          Object.keys(window.AbStor.DefineSlot).map(a => {
            Object.entries(Target).map(a1 => {
              window.AbStor.DefineSlot[a].setTargeting(a1[0], [a1[1]]);
              window.AbStor.keyTarget[a1[0]] = true;
              return '';
            });
            return '';
          });
          window.AbStor.adUnitNameId[adUnit] = slotId;
          window.AbStor.keyTarget[slotId] = TargetingArgumentsString;
          // window.googletag.enableServices();
        } else if (!(Target && dfpNetworkId && adUnit && sizes && slotId)) {
          console.error(
            Target,
            dfpNetworkId,
            adUnit,
            sizes,
            slotId,
            '353f8966-feba-5091-83d1-6fa72df0e9ee',
          );
        }
        return '';
      },
    );
    if (bul) {
      if (!window.AbStor.SlotStart) {
        window.AbStor.SlotStart = true;
        window.googletag.pubads().collapseEmptyDivs();
      }
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();
      time(0);
    }
    /* }); */
  };
  const googletagCmdRefresh = data => {
    const Target = targetingCheck(data[0].targetingArguments);
    const TargetingArgumentsString = `${Object.values(Target).join()}___${(window.location &&
      window.location.href) ||
      ''}`;
    let buf;
    data.map(({ slotId = '' }) => {
      if (window.AbStor.keyTarget[slotId] !== TargetingArgumentsString) {
        window.AbStor.keyTarget[slotId] = TargetingArgumentsString;
        buf = true;
      }
      return '';
    });
    if (!buf || !Target) return '';
    if (__DEVBANNER__) {
      console.info(Target, 'googletagCmdInistaill++++++++++');
    }

    Object.keys(window.AbStor.DefineSlot).map(a => {
      window.AbStor.DefineSlot[a].clearTargeting();
      return '';
    });
    Object.keys(window.AbStor.DefineSlot).map(a => {
      Object.entries(Target).map(a1 => {
        window.AbStor.DefineSlot[a].setTargeting(a1[0], [a1[1]]);
        return '';
      });
      return '';
    });
    clearTimeout(window.AbStor.SetTimeoutrefresh);
    window.AbStor.SetTimeoutrefresh = setTimeout(() => {
      time(0);
    }, 1000);
    return '';
  };

  slots.map(a => {
    if (window.document.getElementById(a.slotId)) {
      if (!window.AbStor.DefineSlot[a.adUnit]) {
        googletagCmdInistaillArr.push(a);
      } else {
        googletagCmdRefreshArr.push(a);
      }
    } else if (defineOutOfPageSlot.ab_mobile_web_catfish === a.slotId) {
      window.App.dispatch(bannerShow());
      googletagCmdInistaillArr.push(a);
    } else {
      console.error(a, 'block id');
    }
    return '';
  });
  if (googletagCmdInistaillArr[0]) {
    googletagCmdInistaill(googletagCmdInistaillArr);
  }
  if (googletagCmdRefreshArr[0]) {
    googletagCmdRefresh(googletagCmdRefreshArr);
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/shared/modules/googletag/googletag.js